import React  from 'react';
import {  updateAllowTransfers,  updateTransferFavorite, setAllTransferStatus } from './helpers/racefunctions';
import { Modal } from 'bootstrap';

function TransferManagement({walletAddress, setModalInfo, transfersAllowed, setTransfersAllowed, transferFavs, setTransferFavs, transferWallets, setTransferWallets, getWalletsForTransfer, getTransferFavs, getTransferStatus, transferAllAllowed, setTransferAllAllowed, getAllTransferStatus}) {



    
	
	const updateTransferStatus = async(e) => {
            var myNameModal = new Modal(document.getElementById('showAlerts'));
            setModalInfo({"message":'Waiting on transfer status update.',"type":'upstart'})
            myNameModal.show();
            const updateResp = await updateAllowTransfers(e.target.checked);
            if (updateResp !== undefined){
                if (updateResp.blockNumber !== '' && updateResp.blockNumber !== undefined){
                    
                    setModalInfo({"message":"Transfer status updated.", "type":"upsupdated" });
                    setTransfersAllowed(e.target.checked);
                    getTransferStatus();
                }else {
                    setModalInfo({"message":'Issue connecting to the blockchain. Please try again.',"type":'error'});
                    return false;
                }
             } else {
                    setModalInfo({"message":'User has rejected the transaction.',"type":'error'});
                    return false;
             }

	}

	const updateTransferAllStatus = async(e) => {
		var myNameModal = new Modal(document.getElementById('showAlerts'));
		setModalInfo({"message":'Waiting on transfer all status update.',"type":'upstart'})
		myNameModal.show();
		const updateResp = await setAllTransferStatus(e.target.checked);
		if (updateResp !== undefined){
			if (updateResp.blockNumber !== '' && updateResp.blockNumber !== undefined){
				
				setModalInfo({"message":"Transfer All status updated.", "type":"upsupdated" });
			//	setTransferAllAllowed(e.target.checked);
			getAllTransferStatus();
			}else {
				setModalInfo({"message":'Issue connecting to the blockchain. Please try again.',"type":'error'});
				return false;
			}
		 } else {
				setModalInfo({"message":'User has rejected the transaction.',"type":'error'});
				return false;
		 }

}
	
	
	const addTransferFavorite = async() => {
		let team = document.getElementById('availableteams').value;
		var myNameModal = new Modal(document.getElementById('showAlerts'));
		setModalInfo({"message":'Waiting on adding favorite.',"type":'addfavestart'})
		myNameModal.show();
		const updateResp = await updateTransferFavorite(walletAddress, team, true);
		console.log(updateResp);
		if (updateResp !== undefined){
			if (updateResp.blockNumber !== '' && updateResp.blockNumber !== undefined){
				
				setModalInfo({"message":"Favorite Added.", "type":"faveadded" });

				getWalletsForTransfer();
				getTransferFavs();
			}else {
				setModalInfo({"message":'Issue connecting to the blockchain. Please try again.',"type":'error'});
				return false;
			}
		 } else {
				setModalInfo({"message":'User has rejected the transaction.',"type":'error'});
				return false;
		 }

	}

	const remTransferFavorite = async(team) => {
		var myNameModal = new Modal(document.getElementById('showAlerts'));
		setModalInfo({"message":'Waiting on removing favorite.',"type":'remfavestart'})
		myNameModal.show();
		const updateResp = await updateTransferFavorite(walletAddress, team, false);
		console.log(updateResp);
		if (updateResp !== undefined){
			if (updateResp.blockNumber !== '' && updateResp.blockNumber !== undefined){
				
				setModalInfo({"message":"Favorite Removed.", "type":"faveremoved" });

				getWalletsForTransfer();
				getTransferFavs();
			}else {
				setModalInfo({"message":'Issue connecting to the blockchain. Please try again.',"type":'error'});
				return false;
			}
		 } else {
				setModalInfo({"message":'User has rejected the transaction.',"type":'error'});
				return false;
		 }
	}

	

    return (
        <div>
				<div>Wallet Transfers allowed? <input type="checkbox" id="tranAllow" checked={transfersAllowed} onChange={(e) => updateTransferStatus(e)} style={{width:'15px'}}/></div>
				<div>Approval for all Transfers Racers? <input type="checkbox" id="tranAllAllow" checked={transferAllAllowed} onChange={(e) => updateTransferAllStatus(e)} style={{width:'15px'}}/><span style={{fontSize:'.8em'}}>(this will allow transfers with one approval instead of approving each)</span></div>
				<div>Teams Available: <select id="availableteams" style={{width:'80%', fontSize:'14px'}}><option>Add to Favorites</option>{transferWallets.map(function(wallets, i) { return <option key={i} value={wallets.address}>{wallets.name} ({wallets.address})</option>})}</select><input type='button' value='Add' style={{width:'50px'}} onClick={() => addTransferFavorite()}/></div>
				<div style={{paddingTop:'20px', fontWeight:'bold'}}>Favorites:</div>
				{transferFavs.map(function(favs, i) {
					return <div key={i}><span style={{fontWeight:'bold'}}>{favs.name}</span> <span style={{fontSize:'.8em'}}>({favs.wallet})</span> <input type="button" value="Remove" onClick={() => remTransferFavorite(favs.wallet)}/></div>
				})}
			</div>
    )

}


export {TransferManagement};